import React, { PureComponent } from 'react';

import { numberFormat } from '~/core/scripts/utils';

class LiveMessage extends PureComponent {
  render() {
    if (!ARTICLE_CONFIG.isLive || ARTICLE_CONFIG.showTeaser || !this.props.data) {
      return null;
    }

    const featureCount = this.props.data.features.length;
    const count = this.props.data.features.reduce((res, feat) => {
      if (feat.properties.Stand === 1) {
        res++;
      }

      return res;
    }, 0);

    const percentage = (count / featureCount) * 100;
    const formattedPercentage = numberFormat(percentage, 2);
    const commaIndex = formattedPercentage.indexOf(',');

    return (
      <div className="livemessage">
        <time className="livemessage-time">Stand: <strong>{ARTICLE_CONFIG.liveTime} Uhr{' '}</strong></time>
        <span className="livemessage-result">
          {count} von {featureCount} Gemeinden ausgezählt {' '} (<strong>{formattedPercentage.substr(0, commaIndex)} %</strong>)
        </span>
      </div>
    );
  }
}

export default LiveMessage;
